// extracted by mini-css-extract-plugin
export default {"btn":"GrayButtonBack_btn__fXZRN"};